import React, { useState } from 'react';
import { useAuth } from '../../contexts/AuthContext';


export function LoginForm() {
  const { signIn, resetPassword } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [showResetPassword, setShowResetPassword] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);

    const { error } = await signIn(email, password);

    if (error) {
      setError(error.message);
    }

    setLoading(false);
  };

  const handleResetPassword = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setMessage(null);

    const { error } = await resetPassword(email);

    if (error) {
      setError(error.message);
    } else {
      setMessage('Check your email for the password reset link!');
      setShowResetPassword(false);
    }

    setLoading(false);
  };

  if (showResetPassword) {
    return (
      <div style={{ maxWidth: '400px', margin: '0 auto', padding: '40px 20px' }}>
        <div style={{
          backgroundColor: '#1a1a1a',
          padding: '40px',
          borderRadius: '8px',
          border: '1px solid #333'
        }}>
          <h2 style={{ textAlign: 'center', marginBottom: '30px', color: 'white' }}>
            Reset Password
          </h2>

          <form onSubmit={handleResetPassword}>
            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '5px', color: 'white' }}>
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px',
                  borderRadius: '4px',
                  border: '1px solid #333',
                  backgroundColor: '#2a2a2a',
                  color: 'white'
                }}
              />
            </div>

            {error && (
              <div style={{
                color: '#ff6b6b',
                marginBottom: '20px',
                padding: '10px',
                backgroundColor: '#2a1a1a',
                border: '1px solid #ff6b6b',
                borderRadius: '4px'
              }}>
                {error}
              </div>
            )}

            {message && (
              <div style={{
                color: '#51cf66',
                marginBottom: '20px',
                padding: '10px',
                backgroundColor: '#1a2a1a',
                border: '1px solid #51cf66',
                borderRadius: '4px'
              }}>
                {message}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#007bff',
                color: 'white',
                border: 'none',
                borderRadius: '4px',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.6 : 1,
                marginBottom: '15px'
              }}
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>

            <button
              type="button"
              onClick={() => setShowResetPassword(false)}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: 'transparent',
                color: '#007bff',
                border: '1px solid #007bff',
                borderRadius: '4px',
                cursor: 'pointer'
              }}
            >
              Back to Login
            </button>
          </form>
        </div>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: '400px', margin: '0 auto', padding: '40px 20px' }}>
      <div style={{
        backgroundColor: '#1a1a1a',
        padding: '40px',
        borderRadius: '8px',
        border: '1px solid #333'
      }}>
        <h2 style={{ textAlign: 'center', marginBottom: '30px', color: 'white' }}>
          Sign In
        </h2>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: 'white' }}>
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '4px',
                border: '1px solid #333',
                backgroundColor: '#2a2a2a',
                color: 'white'
              }}
            />
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '5px', color: 'white' }}>
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: '100%',
                padding: '12px',
                borderRadius: '4px',
                border: '1px solid #333',
                backgroundColor: '#2a2a2a',
                color: 'white'
              }}
            />
          </div>


          {error && (
            <div style={{
              color: '#ff6b6b',
              marginBottom: '20px',
              padding: '10px',
              backgroundColor: '#2a1a1a',
              border: '1px solid #ff6b6b',
              borderRadius: '4px'
            }}>
              {error}
            </div>
          )}

          {message && (
            <div style={{
              color: '#51cf66',
              marginBottom: '20px',
              padding: '10px',
              backgroundColor: '#1a2a1a',
              border: '1px solid #51cf66',
              borderRadius: '4px'
            }}>
              {message}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            style={{
              width: '100%',
              padding: '12px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: loading ? 'not-allowed' : 'pointer',
              opacity: loading ? 0.6 : 1,
              marginBottom: '15px'
            }}
          >
            {loading ? 'Signing In...' : 'Sign In'}
          </button>

          <div style={{ textAlign: 'center' }}>
            <button
              type="button"
              onClick={() => setShowResetPassword(true)}
              style={{
                backgroundColor: 'transparent',
                color: '#007bff',
                border: 'none',
                cursor: 'pointer',
                textDecoration: 'underline',
                fontSize: '14px'
              }}
            >
              Forgot your password?
            </button>

            <div style={{ marginTop: '20px', fontSize: '14px', color: '#8b949e' }}>
              Don't have an account? Contact your administrator.
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}